export default "__VITE_ASSET__D56QWFSB__"